import { ReactComponent as SetTheSetReversed } from "@svgr/webpack?-svgo,+titleProp,+ref!./SetTheSetReversed.svg";
import { ReactComponent as SetLiveDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./SetLiveDefault.svg";
import { ReactComponent as SetLiveReversed } from "@svgr/webpack?-svgo,+titleProp,+ref!./SetLiveReversed.svg";
import { ReactComponent as FacebookDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./FacebookDefault.svg";
import { ReactComponent as TwitterDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./TwitterDefault.svg";
import { ReactComponent as InstagramDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./InstagramDefault.svg";
import { ReactComponent as LinkedInDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./LinkedInDefault.svg";
import { ReactComponent as SetTheSetDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./SetTheSetDefault.svg";
import { ReactComponent as AdWordsDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./AdWordsDefault.svg";
import { ReactComponent as AppleDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./AppleDefault.svg";
import { ReactComponent as BandsInTownDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./BandsInTownDefault.svg";
import { ReactComponent as ChromeDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./ChromeDefault.svg";
import { ReactComponent as FacebookMessengerDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./FacebookMessengerDefault.svg";
import { ReactComponent as GoogleDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./GoogleDefault.svg";
import { ReactComponent as PandoraDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./PandoraDefault.svg";
import { ReactComponent as PinterestDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./PinterestDefault.svg";
import { ReactComponent as RadioDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./RadioDefault.svg";
import { ReactComponent as SkypeDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./SkypeDefault.svg";
import { ReactComponent as SnapchatDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./SnapchatDefault.svg";
import { ReactComponent as SoundCloudDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./SoundCloudDefault.svg";
import { ReactComponent as SpotifyDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./SpotifyDefault.svg";
import { ReactComponent as YouTubeDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./YouTubeDefault.svg";
export const LogoImages = {
  SetTheSetReversed,
  SetLiveDefault,
  SetLiveReversed,
  FacebookDefault,
  TwitterDefault,
  InstagramDefault,
  LinkedInDefault,
  SetTheSetDefault,
  AdWordsDefault,
  AppleDefault,
  BandsInTownDefault,
  ChromeDefault,
  FacebookMessengerDefault,
  GoogleDefault,
  PandoraDefault,
  PinterestDefault,
  RadioDefault,
  SkypeDefault,
  SnapchatDefault,
  SoundCloudDefault,
  SpotifyDefault,
  YouTubeDefault
};
export const LogoNames = ["SetTheSetReversed", "SetLiveDefault", "SetLiveReversed", "FacebookDefault", "TwitterDefault", "InstagramDefault", "LinkedInDefault", "SetTheSetDefault", "AdWordsDefault", "AppleDefault", "BandsInTownDefault", "ChromeDefault", "FacebookMessengerDefault", "GoogleDefault", "PandoraDefault", "PinterestDefault", "RadioDefault", "SkypeDefault", "SnapchatDefault", "SoundCloudDefault", "SpotifyDefault", "YouTubeDefault"];